import Vue from 'vue'
import Router from 'vue-router'
import { IsPC } from '@/utils/tool'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            // component: () => import(/* webpackChunkName: "about" */ '@/views/Home/Home.vue'),
            component: () => {
                if (!IsPC()) {
                    return import(/* webpackChunkName: "about" */ '@/views/Home/mobileHome.vue')
                }
                return import(/* webpackChunkName: "about" */ '@/views/Home/Home.vue')
            },
        },
        {
            path: '/home',
            redirect: '/',
        },
        {
            path: '/product',
            redirect: '/',
        },
        {
            path: '/faq',
            redirect: '/',
        },
        {
            path: '/aboutUs',
            redirect: '/',
        },
        {
            path: '/h5',
            component: () => import(/* webpackChunkName: "h5" */ '@/views/H5.vue'),
            children: [
                {
                    path: 'lazada',
                    component: () => import(/* webpackChunkName: "lazada" */ '@/views/Lazada/index.vue'),
                },
            ],
        },
        {
            path: '/CS',
            component: () => import(/* webpackChunkName: "h5" */ '@/views/CS/index.vue'),
            children: [
                {
                    path: 'M2',
                    component: () => import(/* webpackChunkName: "lazada" */ '@/views/CS/M2/index.vue'),
                },
            ]
        },
    ],
})
